import React, {useState, useRef, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CreateControlAttributesForm from './CreateControlAttributesForm';
import Loader from '../../../../../LoadingIndicator/LoadingIndicator';
import Modal from '../../../../../Modal/Modal';
import {sampleTypes, entities} from '../../../../../../../util/uiconstants';
import Utility from '../../../../../../../util/utilityfunctions';
import {labels} from '../../../../../../../util/utils';
import {useSmartEvidenceSourceId} from '../../../../../../../util/Ares/customHooks';
import {
	createControlAttributes,
	updateControlAttributes
} from '../../../../../../../actions/ControlAttributes/controlattributesaction';

export default function CreateEditControlAttributes(props) {
	const {show, onClose, engagementId, attributeId} = props;
	const dispatch = useDispatch();
	const controlAttributes = useSelector((state) => state.controlAttributes);

	const [isLoading, setIsLoading] = useState(false);
	const [formKey, setFormKey] = useState(0);
	const [attribute, setAttribute] = useState(null);

	const formRef = useRef(null);

	const documentId = Utility.getDocumentIdFromUrl(window);
	const entityUIDINT = useSmartEvidenceSourceId(documentId);

	useEffect(() => {
		if (attributeId) {
			const selectedAttribute = controlAttributes.byId[attributeId];
			if (selectedAttribute) {
				setAttribute(selectedAttribute);
			}
		}
	}, []);

	const onSaveAndClose = async () => {
		const isFormValid = formRef.current.validateForm();
		if (isFormValid) {
			setIsLoading(true);
			const formData = formRef.current.getFormValues();
			try {
				await saveControlAttribute(formData);
				onClose();
			} catch (error) {
				console.log(error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const onSaveAndCreateNew = async () => {
		const isFormValid = formRef.current.validateForm();
		if (isFormValid) {
			setIsLoading(true);
			const formData = formRef.current.getFormValues();
			try {
				await saveControlAttribute(formData);
				resetForm();
			} catch (error) {
				console.log(error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const saveControlAttribute = (data) => {
		const payload = {
			hostDocumentId: documentId,
			entityId: entities.Control,
			entityUIDINT,
			sampleTypeId: sampleTypes.controlAttributeTesting,
			...data
		};

		if (attributeId != null) {
			return dispatch(updateControlAttributes(engagementId, attributeId, payload));
		}

		return dispatch(createControlAttributes(engagementId, payload));
	};

	const resetForm = () => {
		setFormKey((prevKey) => prevKey + 1);
	};

	return (
		<Modal
			className="createEditControlAttributes-motifModal"
			show={show}
			onHide={onClose}
			onOkClick={onSaveAndClose}
			onSaveAndCreateNew={onSaveAndCreateNew}
			disableClose={isLoading}
			isOkButtonDisabled={isLoading}
			isCancelButtonDisabled={isLoading}
			isSaveAndCreateNewButtonDisabled={isLoading}
			title={attributeId !== null ? labels.editControlAttribute : labels.createNewControlAttribute}
			showButtons
			showSaveAndCreateNewButton={attributeId === null}
			confirmBtnTitle={attributeId !== null ? labels.modalSave : labels.modalSaveAndClose}
			closeBtnTitle={labels.modalCancelTitle}
			saveAndCreateNewBtnTitle={labels.modalSaveAndCreateAnother}
			closeTitle={labels.modalCancelTitle}
			modalsize="small"
		>
			{isLoading && (
				<LoaderWrapper>
					<Loader show={isLoading} />
				</LoaderWrapper>
			)}
			<ModalBody className="customScrollbar">
				<Instructions>
					{Utility.createRichTextElement(
						attributeId !== null ? labels.editControlAttributeInstructions : labels.createControlAtttributeInstructions
					)}
				</Instructions>
				<CreateControlAttributesForm ref={formRef} key={formKey} data={attribute} />
			</ModalBody>
		</Modal>
	);
}

CreateEditControlAttributes.propTypes = {
	show: PropTypes.bool,
	onClose: PropTypes.func,
	content: PropTypes.object,
	engagementId: PropTypes.number.isRequired
};

CreateEditControlAttributes.defaultProps = {
	show: false
};

const ModalBody = styled.section``;

const Instructions = styled.section`
	font-size: var(--px-16);
	line-height: var(--px-24);
	margin-bottom: var(--px-24);
`;

const LoaderWrapper = styled.section`
	position: absolute;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	top: 0;
	left: 0;

	&::before {
		content: '';
		background-color: var(--white);
		opacity: 0.5;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
`;
